/* JPI Donate customer-map sizing repair. Additive; does not replace map logic. */
(() => {
  const ROOT_SELECTOR = '[data-jpi-customer-heatmap]';
  const TAB_SELECTOR = '[data-map-tab]';
  const PANEL_SELECTOR = '[data-map-panel]';
  const initializedRoots = new WeakSet();

  function requestMapRedraw(root) {
    if (!root || root.dataset.jpiMapRepairQueued === 'true') return;
    root.dataset.jpiMapRepairQueued = 'true';

    window.requestAnimationFrame(() => {
      window.requestAnimationFrame(() => {
        root.dataset.jpiMapRepairQueued = 'false';
        window.dispatchEvent(new Event('resize'));
      });
    });
  }

  function resetTransientMapState(root, view) {
    root.querySelectorAll('[data-map-float]').forEach((card) => {
      card.classList.remove('is-visible');
      card.hidden = true;
    });

    const canvas = root.querySelector(`[data-map-canvas="${view}"]`);
    const status = root.querySelector('[data-map-status]');
    if (status && canvas?.getAttribute('aria-label')) {
      status.textContent = canvas.getAttribute('aria-label');
    }
  }

  function initialize(root) {
    if (!root || initializedRoots.has(root)) return;
    initializedRoots.add(root);

    root.addEventListener('click', (event) => {
      const tab = event.target.closest(TAB_SELECTOR);
      if (!tab) return;
      resetTransientMapState(root, tab.dataset.mapTab);
      requestMapRedraw(root);
    });

    const mutationObserver = new MutationObserver((records) => {
      if (records.some(({ target }) => target.matches?.(PANEL_SELECTOR))) {
        requestMapRedraw(root);
      }
    });

    root.querySelectorAll(PANEL_SELECTOR).forEach((panel) => {
      mutationObserver.observe(panel, {
        attributeFilter: ['class', 'hidden'],
        attributes: true
      });
    });

    if ('ResizeObserver' in window) {
      let observedWidth = 0;
      const resizeObserver = new ResizeObserver(([entry]) => {
        const nextWidth = Math.round(entry.contentRect.width);
        if (nextWidth > 0 && nextWidth !== observedWidth) {
          observedWidth = nextWidth;
          requestMapRedraw(root);
        }
      });
      resizeObserver.observe(root.querySelector('.jpi-customer-heatmap__panel') || root);
    }

    document.fonts?.ready.then(() => requestMapRedraw(root));

    requestMapRedraw(root);
  }

  function initializeAll(container = document) {
    if (container.matches?.(ROOT_SELECTOR)) initialize(container);
    container.querySelectorAll?.(ROOT_SELECTOR).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  document.addEventListener('shopify:block:select', (event) => initializeAll(event.target));
})();
